import {connect} from 'react-redux';
import actionCreators from '../../actionCreators';
import {updatePreferences} from '../../actionCreators/preferences';
import {findSection, updateSectionValue} from '../../ducks/reportSections';
import AgentBio from './AgentBio';
import './AgentBio.scss';

const mapStateToProps = (state, ownProps) => {
  const reportType = state.reportType.value;

  return {
    ...ownProps,
    reportType,
    section: findSection(state.reportSections, reportType, 'TARGET_PROPERTY'),
    agentName: `${state.userDetails.firstName} ${state.userDetails.lastName}`,
    agentPhoto: state.userDetails.photo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEditAgentBioEvent: (agentIntro, agentNotes) => {
      dispatch(actionCreators.sendEditAgentBioAnalyticsEvent(agentIntro, agentNotes));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    },
    onUpdateIntroduction: (value, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'TARGET_PROPERTY', dataKeyPath: 'sectionData.agentIntro'}));
    },
    onUpdateAgentNotes: (value, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'TARGET_PROPERTY', dataKeyPath: 'sectionData.agentNotes'}));
      dispatch(updateSectionValue({value: true, reportType, key: 'TARGET_PROPERTY', dataKeyPath: 'sectionData.agentNotes_isEdited'}));
    },
    toggleAgentBio: (value, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'TARGET_PROPERTY', dataKeyPath: 'sectionData.toggleProfileBlurb'}));
    },
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onUpdateIntroduction: (value) => {
      dispatchProps.onUpdateIntroduction(value, stateProps.reportType);
    },
    onUpdateAgentNotes: (value) => {
      dispatchProps.onUpdateAgentNotes(value, stateProps.reportType);
    },
    toggleAgentBio: (value) => {
      dispatchProps.toggleAgentBio(value, stateProps.reportType);
    }
  };
};

const ConnectedAgentBio = connect(mapStateToProps, mapDispatchToProps, mergeProps)(AgentBio);

export { ConnectedAgentBio, AgentBio };
export default ConnectedAgentBio;